import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/suspensiones-de-pagos-empleados';

/**
 * GET Suspensiones de Pagos
 * @param {object} params
 * @returns {Promiser<object[]>}
 */
export const getSuspensionesDePagos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Suspension de Pago
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getSuspensionDePago = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Suspension de Pago
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postSuspensionDePago = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Suspension de Pago
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchSuspensionDePago = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Suspension de Pago
 * @param {number} id
 * @return {Promise<boolean>}
 */
export const deleteSuspensionDePago = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Elimiando correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT Suspensiones de Pago Estatus
 * @param {object} values@returns {Promise<{}>}
 */
export const putSuspensionesDePagos = async (values) => {
  try {
    const response = await API.put('nominas/actualizar-estado-suspension-de-pago', values);
    onSuccess(response, 'Suspendido correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT Suspensiones de Pago Estatus
 * @param {object} values@returns {Promise<{}>}
 */
export const putLiberacionesDePagos = async (values) => {
  try {
    const response = await API.put('nominas/actualizar-estado-suspension-de-pago', values);
    onSuccess(response, 'Liberado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT Suspensiones de Pago Estatus
 * @param {object} values@returns {Promise<{}>}
 */
export const putBajasDePagos = async (values) => {
  try {
    const response = await API.put('nominas/actualizar-estado-suspension-de-pago', values);
    onSuccess(response, 'Dado de Baja correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PUT DELETE Suspensiones de Pago Estatus
 * @param {object} values@returns {Promise<{}>}
 */
export const deleteSuspensionesDePagos = async (values) => {
  try {
    const response = await API.put('nominas/eliminar-suspension-de-pago', values);
    onSuccess(response, 'Eliminados correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
